import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { ILeanBrandTile } from "@faire/retailer-visitor-shared/components/LeanBrandTileRenderer/ILeanBrandTileAdapters";
import { useLoggedOutCategoryPageCurrentCategory } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentCategory";
import { useLoggedOutCategoryPageCatNavResponse } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/useLoggedOutCategoryPageCatNavResponse";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import getBrandTileReviews from "@faire/web-api--source/api/v2/products/search/brand-tile-reviews/post";
import { getQueryKey_escape_hatch as getQueryKeyBrandTileReviews } from "@faire/web-api--source/api/v2/products/search/brand-tile-reviews/post-hooks";
import { IBrandTileBrandReviewsRequest } from "@faire/web-api--source/indigofair/data/IBrandTileBrandReviewsRequest";
import { useQuery } from "@tanstack/react-query";
import uniq from "lodash/uniq";
import uniqBy from "lodash/uniqBy";
import { useMemo } from "react";
var STALE_TIME = 1000 * 60 * 5;
export var useLoggedOutCategoryPageBrandTileReviewsResponse = function() {
    var _useLoggedOutCategoryPageCatNavResponse_data;
    var category = useLoggedOutCategoryPageCurrentCategory();
    var shouldGetBrandReviews = !!category.pathIdentifier;
    var productFirstSearchResults = (_useLoggedOutCategoryPageCatNavResponse_data = useLoggedOutCategoryPageCatNavResponse().data) === null || _useLoggedOutCategoryPageCatNavResponse_data === void 0 ? void 0 : _useLoggedOutCategoryPageCatNavResponse_data.productFirstSearchResults;
    var _productFirstSearchResults_map_filter;
    var brandTokens = uniq((_productFirstSearchResults_map_filter = productFirstSearchResults === null || productFirstSearchResults === void 0 ? void 0 : productFirstSearchResults.map(function(p) {
        var _p_brand;
        return (_p_brand = p.brand) === null || _p_brand === void 0 ? void 0 : _p_brand.token;
    }).filter(isNotUndefined)) !== null && _productFirstSearchResults_map_filter !== void 0 ? _productFirstSearchResults_map_filter : []);
    var request = IBrandTileBrandReviewsRequest.build({
        brand_tokens: brandTokens,
        query: category.mostSpecificName.toLowerCase()
    });
    var data = useQuery({
        queryKey: getQueryKeyBrandTileReviews(request),
        queryFn: function() {
            return getBrandTileReviews(request);
        },
        enabled: shouldGetBrandReviews && !!(productFirstSearchResults === null || productFirstSearchResults === void 0 ? void 0 : productFirstSearchResults.length),
        staleTime: STALE_TIME
    }).data;
    return useMemo(function() {
        var _data_brand_tile_reviews;
        var brandReviews = (_data_brand_tile_reviews = data === null || data === void 0 ? void 0 : data.brand_tile_reviews) !== null && _data_brand_tile_reviews !== void 0 ? _data_brand_tile_reviews : [];
        if (!(brandReviews === null || brandReviews === void 0 ? void 0 : brandReviews.length) || !productFirstSearchResults) {
            return [];
        }
        var brands = uniqBy(productFirstSearchResults.map(function(p) {
            return p.brand;
        }), "token");
        var brandTiles = brands.map(function(brand) {
            return ILeanBrandTile.fromLeanProductTileBrand(brand);
        }).filter(isNotUndefined);
        var _brandTiles_map_filter;
        return (_brandTiles_map_filter = brandTiles.map(function(brandTile) {
            var _brandTile_brand;
            return _object_spread_props(_object_spread({}, brandTile), {
                review: ((_brandTile_brand = brandTile.brand) === null || _brandTile_brand === void 0 ? void 0 : _brandTile_brand.token) ? findReviewForBrandTile(brandTile, brandReviews) : undefined
            });
        }).filter(function(item) {
            return item.review !== undefined && item.review.average_rating !== undefined && item.review.total_reviews !== undefined && item.review.review_comment !== undefined;
        })) !== null && _brandTiles_map_filter !== void 0 ? _brandTiles_map_filter : [];
    }, [
        data === null || data === void 0 ? void 0 : data.brand_tile_reviews,
        productFirstSearchResults
    ]);
};
var findReviewForBrandTile = function(brandTile, brandReviews) {
    return brandReviews === null || brandReviews === void 0 ? void 0 : brandReviews.find(function(review) {
        if (brandTile.brand === undefined || brandTile.brand.token === undefined) {
            return false;
        }
        return brandTile.brand.token === review.brand_token;
    });
};
